import { IFetchedAIRecommendation } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

// 글콘티를 이용하여 AI 추천 필터 및 태그 불러오기
async function getTextAIRecommendation(variables: {
  text: string;
  parentOptionId: number;
}): Promise<AxiosResponse<FetchResult<IFetchedAIRecommendation>>> {
  const response = await instance.get(
    `/ai/text-tag-suggestions?text=${encodeURIComponent(variables.text)}&parentOptions=${variables.parentOptionId}`
  );
  return response;
}

// 사용자 액션에 따라 데이터를 조회해야 하므로 useMutation 이용
const useFetchTextAIRecommendation = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['get', `/ai/text-tag-suggestions`],
    mutationFn: (variables: { text: string; parentOptionId: number }) => getTextAIRecommendation(variables),
    retry: false
  });

  return { mutateAsync, isPending };
};

export default useFetchTextAIRecommendation;
